import "./../css/archive.scss";
import $ from 'jquery';

$(document).ready(function () {
    $('.archive__search-icon').on('click', 'svg', function () {
        $(".archive-search").slideToggle('fast');
    });
    $('.archive-filter input').change(function() {
        var slugs = get_filters_archive();
        const params = new URLSearchParams(slugs);
        var url = window.location.href.split('?')[0];
        //console.log(params.toString())
        if(params.toString()){
            window.location.href = url + "?" + params.toString();
        } else {
            window.location.href = url;
        }
    });
    $('.archive__clear-filters').on('click', function() {
        var url = window.location.href.split('?')[0];
        window.location.href = url;
    });
});

/*  pridobivanje izbranih filtrov*/
function get_filters_archive() {
    var slugs = {};
    $(".archive-filter").each(function () {
        var taxonomy = $(this).data("name");
        var temp = [];
        $(this).find("input[type='checkbox']:checked").each(function () {
            temp.push(parseInt($(this).attr("value")));
        })
        if ($(this).find("input[name=search]").val()){
            temp.push($(this).find("input[name=search]").val());
        }
        if (temp.length > 0) {
            slugs["_"+taxonomy] = temp ;
        }
    });
    return slugs;
}